import React, { FC, useState } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import {
  DateRange,
  ExpandLess,
  HourglassBottom,
  MoreVert,
  Person,
  Shield,
} from '@mui/icons-material';
import Block from '../../Block/Block';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const SanegoReview: FC<Props> = ({
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);

  const {
    text,
    rating,
    medicalPractitioner,
    treatmentDuration,
    insurance,
    gender,
    age,
    waitingTimeAppointment,
    waitingTimeInWaitingRoom,
    blocks,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={true}
      rating={rating}
      reviewFor={medicalPractitioner}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {gender && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <Person fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {gender} {age && age !== 'nicht angegeben' && `(${age})`}
          </Typography>
        </Box>
      )}
      {treatmentDuration && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <DateRange fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {t('treatment_of')} {treatmentDuration}
          </Typography>
        </Box>
      )}
      {insurance && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <Shield fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {insurance}
          </Typography>
        </Box>
      )}
      {waitingTimeAppointment && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <HourglassBottom fontSize="small" />
          <Typography
            variant="caption"
            sx={{ ml: theme.spacing(1) }}
          >
            {t('appointment')} {waitingTimeAppointment}
          </Typography>
        </Box>
      )}
      {waitingTimeInWaitingRoom && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <HourglassBottom fontSize="small" />
          <Typography
            variant="caption"
            sx={{ ml: theme.spacing(1) }}
          >
            {t('waiting_room')} {waitingTimeInWaitingRoom}
          </Typography>
        </Box>
      )}
      <ReviewText text={text} />
      {blocks && blocks.length > 0 && (
        <Box sx={{ mt: theme.spacing(2) }}>
          {showAllBlocks ? (
            blocks
              .filter((value) => typeof value.rating === 'number')
              .map(({ rating, text, title }, index) => {
                return (
                  <Box
                    key={`Review_${reviewEntry.id}_Block_${index}`}
                    sx={{ mt: theme.spacing(1) }}
                  >
                    <Divider orientation="horizontal" />
                    <Block
                      rating={rating}
                      text={text}
                      title={title}
                    />
                  </Box>
                );
              })
          ) : (
            <Box sx={{ mt: theme.spacing(1) }}>
              <Divider orientation="horizontal" />
              <Block
                rating={blocks[0].rating}
                text={blocks[0].text}
                title={blocks[0].title}
              />
            </Box>
          )}
          <Button
            variant="outlined"
            size="small"
            startIcon={showAllBlocks ? <ExpandLess /> : <MoreVert />}
            onClick={() => setShowAllBlocks(!showAllBlocks)}
            sx={{
              mb: theme.spacing(1),
            }}
          >
            {showAllBlocks ? t('show_less') : t('show_more')}
          </Button>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default SanegoReview;
